<template>
  <m-dialog ref="previewKategoriDlg" :btnsave="false" title="Cetak KTA Berdasarkan Nama">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="12" lg="10" xl="7">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="title black--text mb-2">Cari berdasarkan Kategori</p>
                <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                  <v-select
                    dense
                    outlined
                    height="50"
                    placeholder="Pilih Kategori"
                    :items="itemKategori"
                    v-model="selected"
                    item-value="id"
                    item-text="nama"
                    return-object
                    label="Kategori"
                  >
                  </v-select>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :small="$vuetify.breakpoint.smAndDown" :disabled="selected ? false : true" depressed color="info" @click="unduhXls()"> <v-icon>mdi-xls</v-icon>UNDUH XLS</v-btn>
            <v-btn :small="$vuetify.breakpoint.smAndDown" :disabled="selected ? false : true" depressed color="success" @click="cetakKTA()">
              <v-icon>mdi-file-pdf-box</v-icon>CETAK KTA</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <PreviewCustomNameDlg ref="previewCustomNameDlg" />
  </m-dialog>
</template>

<script>
// const lc = window.localStorage;
// const TOKEN = "siapbbjatimtoken";
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
import PreviewCustomNameDlg from "../../warga/components/PreviewKTAKTPByName.vue";
// import { API } from "@/const";
// const M_API = API + "/api";
export default {
  components: {
    VueEditor,
    PreviewCustomNameDlg
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      items: [],
      itemKategori: [
        {
          id: 3,
          nama: "PAC"
        },
        {
          id: 4,
          nama: "DPC"
        },
        {
          id: 5,
          nama: "DPW"
        },
        {
          id: 6,
          nama: "DPP"
        }
      ],
      selected: null,
      search: null,
      kotaid: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(filtered) {
      this.items = [];
      this.filtered = filtered;
      let x = this.$refs.previewKategoriDlg.open();
      this.$validator.reset();
      this.selected = null;
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },

    // previewKTA() {
    //   this.$store
    //     .dispatch("warga/previewByNama", { obj: this.selected, kota_id: this.kotaid })
    //     .then(res => {
    //       this.items = res;
    //     })
    //     .catch(e => e);
    // },
    previewCustom(items, kotaid) {
      this.$refs.previewCustomNameDlg.open(items, kotaid).then(() => {
        this.load();
      });
    },
    unduhXls() {
      this.$store
        .dispatch("warga/downloadKategoriXls", {
          obj: this.selected,
          params: {
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id
          }
        })
        .then(() => {})
        .catch(e => e);
    },
    cetakKTA() {
      this.$store
        .dispatch("warga/cetakCustomByKategori", {
          obj: this.selected,
          params: {
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id
          }
        })
        .then(() => {})
        .catch(e => e);
    }
  }
};
</script>
